import { LoanActionType } from '../LoanConstants';

export const getLoanInsuranceActions = (loan: { id: number; propertyId: number }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions: any[] = [];

    actions.push({
        id: LoanActionType.Modify,
        text: 'Loan Details',
        loanId: loan.id,
        //icon: 'edit',
        stylingMode: 'contained',
    });

    actions.push({
        id: LoanActionType.Insurance,
        text: 'Insurances',
        loanId: loan.id,
        propertyId: loan.propertyId,
        //icon: 'edit',
        stylingMode: 'contained',
    });

    return actions;
};
